import { Combobox } from "../../../components/ui/combobox";
import { useState } from "react";
import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { FiltersInput } from "../FiltersButton";
import { fetch } from "@/src/lib/fetch";

export type Operator = {
  id: string;
  name: string;
};

export const Operator = ({ defaultValue }: { defaultValue?: Operator | null }) => {
  const [operator, setOperator] = useState<Operator | null>(defaultValue || null);

  return (
    <FormField<FiltersInput, "operator">
      name="operator"
      render={({ field }) => {
        return (
          <FormItem className="flex-grow w-1/2">
            <FormLabel className="text-xl text-semibold">Operator</FormLabel>
            <FormControl>
              <Combobox
                className="flex w-full"
                loadOptions={(query) =>
                  fetch<{ data: Operator[] }>(`/api/operators/operators?pageSize=5&filter=${query}`).then((r) => r.data)
                }
                placeholder="Search for operator..."
                value={operator}
                onChange={(v) => {
                  if (v && v.id !== operator?.id) {
                    setOperator(v);
                    field.onChange(v);
                  } else {
                    setOperator(null);
                    field.onChange(null);
                  }
                }}
                renderOption={(r) => r.name}
              />
            </FormControl>
          </FormItem>
        );
      }}
    />
  );
};
